import { forwardRef } from "react";

import { TextProps } from "./types";
import { TextBase } from "./styles";

/**
 * Text component with dynamic font size and weight.
 * @param {Object} props - Component props
 * @param {string} [component] [default: "p"] - HTML tag to render (p, span) ;
 * @param {string} [$variant] [default: "default"] - Primary (gray.900) | Secondary (gray.600) ;
 * @param {string} [$fs] [default: "t16"] - Font size from theme ;
 * @param {string} [$fw] [default: "regular"] - Font weight from theme ;
 * @param {string} [$lh] [default: "lh140"] - Line height from theme ;
 */

const Text = forwardRef<HTMLElement, TextProps>(
  (
    {
      $variant = "default",
      component = "p",
      $fs = "t16",
      $fw = "regular",
      $lh = "lh140",
      $p,
      $m,
      ...rest
    },
    ref,
  ) => {
    return (
      <>
        <TextBase
          ref={ref}
          $variant={$variant}
          as={component}
          $fs={$fs}
          $fw={$fw}
          $lh={$lh}
          $p={$p}
          $m={$m}
          {...rest}
        />
      </>
    );
  },
);

export default Text;
